import { createGlobalStyle } from 'styled-components'

export const GlobalStyle = createGlobalStyle`
  :root {
    --layout-width: 1140px;

    --color-primary: #007faa;
    --color-text: #2e353f;
    --color-text-light: #4f5969;
    --color-heading: #1a202c;
    --color-heading-black: black;
    --color-accent: #d1dce5;

    --radius: 5px;
    --headerHeight: 60px;

    --link-color: #202428;
    --link-color-hover: var(--color-primary);

    --tag-color: #656565;
    --tag-color-hover: #08090a;

    --maxWidth-none: "none";
    --maxWidth-xs: 20rem;
    --maxWidth-sm: 24rem;
    --maxWidth-md: 28rem;
    --maxWidth-lg: 32rem;
    --maxWidth-xl: 36rem;
    --maxWidth-2xl: 42rem;
    --maxWidth-3xl: 48rem;
    --maxWidth-4xl: 56rem;
    --maxWidth-5xl: 64rem;
    --maxWidth-full: "100%";
    --maxWidth-wrapper: 64rem;

    --spacing-px: "1px";
    --spacing-0: 0;
    --spacing-1: 0.25rem;
    --spacing-2: 0.5rem;
    --spacing-3: 0.75rem;
    --spacing-4: 1rem;
    --spacing-5: 1.25rem;
    --spacing-6: 1.5rem;
    --spacing-8: 2rem;
    --spacing-10: 2.5rem;
    --spacing-12: 3rem;
    --spacing-16: 4rem;
    --spacing-20: 5rem;
    --spacing-24: 6rem;
    --spacing-32: 8rem;

    --fontWeight-normal: 400;
    --fontWeight-medium: 500;
    --fontWeight-semibold: 600;
    --fontWeight-bold: 700;
    --fontWeight-extrabold: 800;
    --fontWeight-black: 900;

    --fontSize-root: 16px;

    --lineHeight-none: 1;
    --lineHeight-tight: 1.1;
    --lineHeight-normal: 1.5;
    --lineHeight-relaxed: 1.625;

    /* 1.200 Minor Third Type Scale */
    --fontSize-0: 0.833rem;
    --fontSize-1: 1rem;
    --fontSize-2: 1.2rem;
    --fontSize-3: 1.44rem;
    --fontSize-4: 1.728rem;
    --fontSize-5: 2.074rem;
    --fontSize-6: 2.488rem;
    --fontSize-7: 2.986rem;
  }
  
  /* HTML elements */

  html {
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }

  h1 > a,
  h2 > a,
  h3 > a,
  h4 > a,
  h5 > a,
  h6 > a {
    color: var(--color-heading);
  }
    
  a {
    color: var(--color-primary);
    text-decoration: none;
  }
  
  blockquote {
    margin-left: 0;
    padding: var(--spacing-0) var(--spacing-0) var(--spacing-0) var(--spacing-4);
    border-left: var(--spacing-1) solid var(--color-primary);
    font-style: italic;
    color: var(--color-text-light);
  }

  /* Code block */
  .gatsby-highlight {
    margin-bottom: 1.63rem;
  }

  // Fix clicking on the Table of Content links for jumping to a heading
  // https://stackoverflow.com/a/28824157
  :target::before {
    content: "";
    display: block;
    height: var(--headerHeight);
    margin: calc(-1 * var(--headerHeight)) 0 0;
  }
`
